/**
 *  const selectTab = valueFromTargetDataset('value')((value) => {
 *    console.log(value); // value = "DETAILS"
 *  });
 *
 *  <button data-value="DETAILS" onClick={selectTab}/>
 *
 * @param datasetKey
 */
export const valueFromTargetDataset =
  (datasetKey: string) =>
  <Return>(handler: (value?: string) => Return) =>
  <Element extends HTMLElement>(e: { currentTarget: Element }) =>
    handler(e.currentTarget.dataset[datasetKey]);

/**
 *  const selectTab =
 *  valueFromTargetValue((value) => {
 *    console.log(value); // value = "DETAILS"
 *  });
 *
 *  <select onChange={selectTab}>
 *    <option value="DETAILS"/>
 *  </select>
 *
 * @param handler
 */
export const valueFromTargetValue =
  <Return, Value>(handler: (value: Value) => Return) =>
  <Element extends { value: Value }>(e: { currentTarget: Element }) =>
    handler(e.currentTarget.value);
